/**
 * Константи для CrudResource Feature
 * Містить тексти за замовчуванням та інші конфігураційні значення
 */

/**
 * Тексти за замовчуванням для табличного режиму CRUD
 * Використовується в меню дій та інших елементах інтерфейсу
 */
export const AddTableModeCrudFeature = {
    defaultTexts: {
        view: 'Переглянути',
        edit: 'Редагувати',
        delete: 'Видалити',
        deleteConfirm: 'Ви впевнені що хочете видалити цей запис?',
        yes: 'Так',
        no: 'Ні',
        table: 'Таблиця',
    },
}
